import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const DashboardIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M4 15a8 8 0 1 1 16 0h2c0-5.523-4.477-10-10-10S2 9.477 2 15z" />
    <path
      fill="currentColor"
      d="M14 16a2 2 0 1 1-2.268-1.982l1.216-2.386.946-1.893 1.79.894-.637 1.273.005.002-.319.625L13.6 14.8c.251.334.4.75.4 1.2"
    />
  </BaseIcon>
)
